var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "java内置队列"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#java内置队列"
    }
  }, [_vm._v("#")]), _vm._v(" Java内置队列")]), _vm._v(" "), _c('p', [_vm._v("实现类")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("LinkedBlockingQueue: 基于链表实现的阻塞队列")]), _vm._v(" "), _c('li', [_vm._v("ArrayBlockingQueue: 基于数组实现的阻塞队列")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "添加元素"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#添加元素"
    }
  }, [_vm._v("#")]), _vm._v(" 添加元素")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("方法")]), _vm._v(" "), _c('th', [_vm._v("返回值")]), _vm._v(" "), _c('th', [_vm._v("描述")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("add()")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("如果可以在不违反容量限制的情况下立即执行此操作，则将指定的元素插入此队列，成功时返回 true ，如果当前没有空间，则抛出 IllegalStateException 。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("put()")]), _vm._v(" "), _c('td', [_vm._v("void")]), _vm._v(" "), _c('td', [_vm._v("将指定的元素插入此队列，等待空间变为可用。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("offer()")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("将指定的元素插入此队列中，如果它是立即可行且不会违反容量限制，返回 true在成功和 false ，如果当前没有空间可用。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("offer(E e, long timeout, TimeUnit unit)")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("将指定的元素插入此队列，如果需要空间可用，则等待指定的等待时间。")])])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "检索元素"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#检索元素"
    }
  }, [_vm._v("#")]), _vm._v(" 检索元素")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("方法")]), _vm._v(" "), _c('th', [_vm._v("返回值")]), _vm._v(" "), _c('th', [_vm._v("描述")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("take()")]), _vm._v(" "), _c('td', [_vm._v("<E>")]), _vm._v(" "), _c('td', [_vm._v("检索并删除此队列的头部，必要时等待，直到元素可用。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("poll(long timeout, TimeUnit unit)")]), _vm._v(" "), _c('td', [_vm._v("<E>")]), _vm._v(" "), _c('td', [_vm._v("检索并删除此队列的头部，如果元素可用，则等待指定的等待时间。")])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };